import { render } from "./HeroiconsSolidPrinter.vue?vue&type=template&id=76be5a0c"
const script = {}

import exportComponent from "/home/roland/vscode/yachtbroker/portal/vendor/laravel/nova/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"HeroiconsSolidPrinter.vue"]])

export default __exports__